// src/components/Navbar.jsx
import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { MenuIcon, XIcon } from "@heroicons/react/outline";

const Navbar = () => {
   const [isOpen, setIsOpen] = useState(false);

   const menuItems = [
      { name: "Редакция туралы", path: "/about" },
      { name: "Жарнама", path: "/advertise" },
      { name: "Қоғам", path: "/society" },
      { name: "Саясат", path: "/politics" },
      { name: "Мәдениет", path: "/culture" },
      { name: "Спорт", path: "/sports" },
      // { name: "Происшествия", path: "/incidents" },
      { name: "Білім", path: "/education" },
   ];

   return (
      <nav className="bg-white shadow-md fixed w-full z-10">
         <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            <div className="flex justify-between h-16">
               {/* Логотип или название сайта */}
               <div className="flex-shrink-0 flex items-center">
                  <NavLink to="/" className="text-xl font-bold text-gray-800">
                     АМАНКЕЛДІ АРАЙЫ
                  </NavLink>
               </div>

               {/* Кнопка гамбургера для мобильных устройств */}
               <div className="flex items-center sm:hidden">
                  <button
                     onClick={() => setIsOpen(!isOpen)}
                     type="button"
                     className="inline-flex items-center justify-center p-2 rounded-md text-gray-800 hover:text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-offset-gray-800 focus:ring-white"
                     aria-controls="mobile-menu"
                     aria-expanded={isOpen}
                  >
                     <span className="sr-only">Открыть главное меню</span>
                     {isOpen ? (
                        <XIcon className="block h-6 w-6" aria-hidden="true" />
                     ) : (
                        <MenuIcon className="block h-6 w-6" aria-hidden="true" />
                     )}
                  </button>
               </div>

               <div className="hidden sm:ml-6 sm:flex sm:space-x-4">
                  {menuItems.map((item) => (
                     <NavLink
                        key={item.name}
                        to={item.path}
                        className={({ isActive }) =>
                           isActive
                              ? "px-3 py-2 rounded-md text-sm font-medium text-white bg-gray-800 flex items-center"
                              : "px-3 py-2 rounded-md text-sm font-medium text-gray-800 hover:bg-gray-200 flex items-center"
                        }
                        onClick={() => setIsOpen(false)}
                     >
                        {item.name}
                     </NavLink>
                  ))}
               </div>
            </div>
         </div>

         {/* Меню для мобильных устройств */}
         {isOpen && (
            <div className="sm:hidden transition-all duration-300 ease-in-out" id="mobile-menu">
               <div className="px-2 pt-2 pb-3 space-y-1">
                  {menuItems.map((item) => (
                     <NavLink
                        key={item.name}
                        to={item.path}
                        className={({ isActive }) =>
                           isActive
                              ? "block px-3 py-2 rounded-md text-base font-medium text-white bg-gray-800"
                              : "block px-3 py-2 rounded-md text-base font-medium text-gray-800 hover:bg-gray-200"
                        }
                        onClick={() => setIsOpen(false)} // Закрыть мобильное меню при клике
                     >
                        {item.name}
                     </NavLink>
                  ))}
               </div>
            </div>
         )}
      </nav>
   );
};

export default Navbar;
